import React from 'react';
import { useIntl } from 'react-intl';
import Link from 'next/link';
import { Container } from 'reactstrap';
import classNames from 'classnames';
import { faQuestion } from '@fortawesome/pro-solid-svg-icons/faQuestion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Category } from './types';
import style from './Categories.module.scss';
import FeatureWalrus from '../../../../../public/statics/svgs/feature-walrus.svg';
import { CategoryImages, CategoryImagesEnum } from './images';

export const NewQuestionElement: React.FC = React.memo(() => {
  return (
    <div className="flex align-items-center justify-content-center flex-column py-3">
      <div className={style.wrapper}>
        <div className={classNames('d-flex align-items-center justify-content-center', style.image)}>
          <FeatureWalrus />
        </div>
        <div className={classNames('d-flex align-items-center justify-content-center', style.icon)}>
          <FontAwesomeIcon icon={faQuestion} className="m-0" />
        </div>
      </div>
    </div>
  );
});

const CategoryNewQuestionElement: React.FC = () => {
  const intl = useIntl();
  return (
    <div className={classNames('mx-3 my-5', style.box)}>
      <Link
        prefetch={false}
        href="/features"
        passHref
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <NewQuestionElement />
        <div className={classNames('d-flex align-items-center justify-content-center', style.categoryNameNewQuestions)}>
          {intl.formatMessage({
            id: 'web.categories.new_question',
            defaultMessage: 'Create new questions'
          })}
        </div>
      </Link>
    </div>
  );
};

const CategoryElement: React.FC<{ category: Category }> = ({ category }) => {
  const Image = CategoryImages[category.imageIdentifier ?? CategoryImagesEnum.General];
  return (
    <div className={classNames('mx-3 my-5', style.box)}>
      <Link
        prefetch={false}
        href={`/questions/categories/${category.slug}`}
        passHref
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <div
          style={{ height: 200 }}
          className={classNames('d-flex align-items-center justify-content-center mb-3', style.categoryImage)}
        >
          <Image />
        </div>
        <div className={classNames('d-flex align-items-center justify-content-center', style.categoryName)}>
          {category.name}
        </div>
      </Link>
    </div>
  );
};
export const CategoriesList: React.FC<{ categories: Category[] }> = React.memo(({ categories }) => {
  const intl = useIntl();
  return (
    <Container>
      <div className="d-flex flex-row flex-wrap align-items-center justify-content-center">
        {categories.map((category) => (
          <CategoryElement key={category.slug} category={category} />
        ))}
      </div>
      <div className={classNames('d-flex align-items-center justify-content-center flex-column', style.boxWrapper)}>
        <div className={classNames('mt-5 d-flex align-items-center justify-content-center', style.text)}>
          {intl.formatMessage({
            id: 'web.categories.create_own_questions',
            defaultMessage: 'Create your own questions!'
          })}
        </div>
        <div className="d-flex flex-row align-items-center justify-content-center">
          <CategoryNewQuestionElement />
        </div>
      </div>
    </Container>
  );
});
